/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  


/*============ Add any custom scripts below this line ==================*/

$(function () {
  function getFirebaseCloudFunctionUrl(id) {
    const url = `https://${id}-rgkt6f5sia-uc.a.run.app`;
    return url.toLowerCase();
  }

  /*======= Delay Homepage Modal =========*/
  window.setTimeout(() => {
    $("#delayModal").toggle();
  }, 5000);

  /*======= Toast Notifications =========*/
  function closeToast() {
    return $("#toast").hide();
  }
  
 

  // Limit Min date of Booking Modal
 // document.getElementById("date").min = new Date().toISOString().split("T")[0];

  

   
  /*======= Contact Form Modal =========*/
  function hideModal() {
    $(".modal_content").hide();
    $(".form-response").show();
  }

  function showModal(evt) {
    evt.preventDefault();
    $(".modal_content").show();
    $(".form-response").hide();
    $(".contact-form").trigger("reset");
    $(".send_form").show();
    $(".sending_form").hide();
  }

  // Get Product Variants
  var productVariants = [];
  function getVariableSelected() {
    productVariants = [];
    var allVariants = document.querySelectorAll('input[type="radio"]');
    for (i = 0; i < allVariants.length; i++) {
      if (allVariants[i].checked) {
        productVariants.push(
          `${allVariants[i].name} : ${allVariants[i].value}`,
        );
      }
    }
  }

  function initProductModalContent(evt, title) {
    showModal(evt);
    $("#ContactModal").show();
    $("#ContactModal .modal__subtitle").html(title);
    $("#ContactModal .modal__description").html(
      "<p>Please share your information to submit your request.</p>",
    );
    $("#ContactModal #message").attr("placeholder", "Leave your message here");
    getVariableSelected();
  }

  // Footer Email Link
  $(".site-footer .rte p a").on("click", function (evt) {
    initProductModalContent(evt, "Contact Us");
  });
  // ProductModal
  $("#btn-product-questions").on("click", function (evt) {
    initProductModalContent(evt, "Jewellery Enquiry");
  });

  // RequestModal
  $("#btn-customise").on("click", function (evt) {
    showModal(evt); 
    $("#ContactModal").show();
    $("#ContactModal .modal__subtitle").html("ASK A QUESTION");
    $("#ContactModal .modal__description").html(
      "<p>Please share your information below to submit your enquiry.</p>",
    );
    $("#ContactModal #message").attr(
      "placeholder",
      "Please include the Item name and your comments.",
    );
  });

  // Close Modal
  $("#ContactModal .modal--newsletter a.close").on("click", function (evt) {
    evt.preventDefault();
    $("#ContactModal").hide();
  });

  // Submit Modal Form
  $("#ContactModal #contact_form").submit(function (e) { 
    e.preventDefault(); 
    $(".send_form").hide();
    $(".sending_form").show();

    var data = {
      title: document.querySelector("#ContactModal .modal__subtitle").innerHTML,
      name: document.querySelector('[name="name"]').value,
      email: document.querySelector('[name="email"]').value,
      phone: document.querySelector('[name="phone"]').value,
      country: document.querySelector('[name="country"]').value,
      state: document.querySelector('[name="state"]').value,
      message: document.querySelector('[name="message"]').value,
      productTitle: document.querySelector('[name="product_title"]').value,
      productSku: document.querySelector('[name="product_sku"]').value,
      productVariants: productVariants.toString(),
    };

    axios({
      method: "post",
      url: getFirebaseCloudFunctionUrl("sendContactEmail"),
      data: data,
    }).then(function (response) {
      hideModal();
      console.log('testing', data)
    });
  });
    
  function sendDataToAPI() {
    const paymentSection = document.getElementById("paymentSection"); // Replace 'myForm' with the ID of your form element
    const form = document.getElementById("paymentGateway"); // Replace 'myForm' with the ID of your form element
    const submitButton = document.getElementById("submitPayment"); // Replace 'myForm' with the ID of your form element
    const redirectedSection = document.getElementById("paymentRedirected"); // Replace 'myForm' with the ID of your form element

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      // Update submit button
      submitButton.value = "Processing...";
      submitButton.setAttribute("disabled", true);

      // Get form data
      const formData = new FormData(form);
      const jsonData = {};

      // Convert form data to JSON
      for (let [key, value] of formData.entries()) {
        jsonData[key] = value;
      }

      // Send POST request to API
      axios({
        method: "post",
        url: getFirebaseCloudFunctionUrl("processPayment"),
        data: jsonData,
      })
        .then(function (response) {
          // Show redirection message
          paymentSection.style.display = "none";
          redirectedSection.style.display = "flex";

          const { data } = response;
          if (data.success && data.returnType === "REDIRECT") {
            window.location.href = data.redirectUrl; // Redirect to the payment url
            // window.open(data.redirectUrl, "_blank"); // Redirect to the payment url
          }
        })
        .catch((error) => {
          // $("#modal-response").toggle();
          console.error("Error:", error);
        });
    });
  }
  if(document.getElementById("paymentGateway"))
    sendDataToAPI();
  });

 // tabbed content
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".tab_content").hide();
    $(".tab_content:first").show();

  /* if in tab mode */
    $("ul.tabs li").click(function() {
		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();		
		
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".tab_drawer_heading").removeClass("d_active");
	  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    /*$(".tabs").css("margin-top", function(){ 
       return ($(".tab_container").outerHeight() - $(".tabs").outerHeight() ) / 2;
    });*/
    });
    $(".tab_container").css("min-height", function(){ 
      return $(".tabs").outerHeight() + 50;
    });
	/* if in drawer mode */
	$(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
	  
	  $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
	  
	  $("ul.tabs li").removeClass("active");
	  $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
	
 

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.



 // Booking Modal Button
  $(".footer-booking").on("click", function (evt) {
    showModal(evt);
    $("#BookingModal").show();
    $("#BookingModal .modal__subtitle").html("Appointment Booking");
    $("#BookingModal .modal__description").html(
      "<p>Please share your information to schedule your in-store appointment.</p>",
    );
    $("#BookingModal #message").attr("placeholder", "Leave your message here");
  });
 

  // Limit Min date of Booking Modal
  if(document.getElementById("date"))
  document.getElementById("date").min = new Date().toISOString().split("T")[0];

  // Booking Modal Submit
  $("#BookingModal").submit(function (event) {
    event.preventDefault();
    $(".send_form").hide();
    $(".sending_form").show();

    var fields = {};
    $("#BookingModal")
      .find("input, textarea, select")
      .each(function () {
        fields[this.name] = $(this).val();
      });

    var data = new Object(fields);
    axios({
      method: "post",
      url: "https://sendbookingemail-rgkt6f5sia-uc.a.run.app",
      data: data,
    }).then(function (response) {
      $(".modal_content").hide();
      $(".form-response").show();
      console.log('testing', data)
    });
  });

  // Close Modal
  $("#BookingModal .modal--newsletter a.close").on("click", function (evt) {
    evt.preventDefault();
    $("#BookingModal").hide();
  });

  /*======= Generate Branchs =========*/
  var branch_arr = new Array("Sydney", "Melbourne", "Brisbane");

  function populateBranchs(branchElementId, dateElementId) {
    var branchElement = document.getElementById(branchElementId);
    if(branchElement){
    branchElement.length = 0;
    branchElement.options[0] = new Option("Select a Salon", "");
    branchElement.selectedIndex = 0;
    for (var i = 0; i < branch_arr.length; i++) {
      branchElement.options[branchElement.length] = new Option(
        branch_arr[i],
        branch_arr[i],
      );
    }
    }
  }

  /*======= Generate Branch Times =========*/
  var x = 30; //minutes interval
  var branchTimes = []; // time array
  var tt = 600; // start time
  var ap = ["AM", "PM"]; // AM-PM

  //loop to increment the time and push results in array
  for (var i = 0; tt < 17 * 60; i++) {
    var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
    var mm = tt % 60; // getting minutes of the hour in 0-55 format
    if (hh === 12) {
      branchTimes[i] =
        "12" + ":" + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
    } else {
      branchTimes[i] =
        ("0" + (hh % 12)).slice(-2) +
        ":" +
        ("0" + mm).slice(-2) +
        ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
    }
    tt = tt + x;
  }

  /*======= Populate Branch Times =========*/
  function populateBranchTimes(branchElementId) {
    var branchElement = document.getElementById(branchElementId);
    if(branchElement){
    branchElement.length = 0;
    branchElement.options[0] = new Option("Select a Time", "");
    branchElement.selectedIndex = 0;
    for (var i = 0; i < branchTimes.length; i++) {
      branchElement.options[branchElement.length] = new Option(
        branchTimes[i],
        branchTimes[i],
      );
    }
    }
  }

  function BranchTimes(branchElementId) {
    var branchElement = document.getElementById(branchElementId);
    if(branchElement){
    branchElement.length = 0;
    branchElement.options[0] = new Option("Select a Time", "");
    branchElement.selectedIndex = 0;
    for (var i = 0; i < branchTimes.length; i++) {
      branchElement.options[branchElement.length] = new Option(
        branchTimes[i],
        branchTimes[i],
      );
    }
    }
  }

//   function populateBranchTimes(branchElementId) {
//   var branchElement = document.getElementById(branchElementId);
//   if (branchElement) {
//     branchElement.length = 0;
//     branchElement.options[0] = new Option("Select a Time", "");
//     branchElement.selectedIndex = 0;

//     // Get the current day of the week
//     var today = new Date().getDay();

//     // Define available times for each day
//     var availableTimes = [];

//     if (today === 6) { // Saturday
//       availableTimes = ["10:00AM"];
//     } else if (today === 0) { // Sunday
//       availableTimes = ["11:00AM"];
//     } else { // Monday to Friday
//       availableTimes = ["10:00AM", "11:00AM", "3:00PM", "4:00PM"];
//     }

//     // Populate the dropdown with available times
//     for (var i = 0; i < availableTimes.length; i++) {
//       branchElement.options[branchElement.length] = new Option(
//         availableTimes[i],
//         availableTimes[i]
//       );
//     }
//   }
// }

  // Run scripts to populate the input fields
  populateBranchs("salon");
  populateBranchTimes("time");
  BranchTimes("times");
})();